export function isInputDOMNode(event: KeyboardEvent): boolean {
  const target = (event.composedPath?.()?.[0] || event.target) as HTMLElement

  const hasAttribute =
    typeof target?.hasAttribute === 'function'
      ? target.hasAttribute('contenteditable')
      : false

  const closest =
    typeof target?.closest === 'function' ? target.closest('.nokey') : null

  // when an input field is focused we don't want to trigger deletion or movement of nodes
  return (
    ['INPUT', 'SELECT', 'TEXTAREA'].includes(target?.nodeName) ||
    hasAttribute ||
    !!closest
  )
}
